import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import ErrorIcon from '../../../assets/images/icon_error_messages.gif';
import Label from './common/label';

const SalesManager = ({ labels, errors, touched, role }) => {
  const getFieldLabel = () =>
    +role === 2 ? labels.SALE_MANAGER : labels.MANAGER;
  return (
    <>
      <Label labelName={getFieldLabel()} />
      <div
        style={{ position: 'relative' }}
        className={`input-container ${
          errors.salesManager && touched.salesManager ? 'error' : ''
        }`}
      >
        <Field
          placeholder={labels.PLACEHOLDER_MANAGER}
          name="salesManager"
          className="select-style"
          type="text"
        />
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px">{errors.salesManager}</span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
        </>
      </div>
    </>
  );
};

SalesManager.propTypes = {
  labels: PropTypes.isRequired,
  errors: PropTypes.isRequired,
  touched: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired
};

export default SalesManager;
